<template>
  <div class="Subtitles">
    <div class="Subtitles__text" ref="subtitle" v-for="subtitle in subtitles" v-html="subtitle" />
  </div>
</template>

<script>
export default {
  name: 'ChapterSubtitles',
  props: ['subtitles', 'name'],
  data: ()=>({
    completed: false
  }),
  watch: {
    $route() {
      this.playPauseChecker(this.$route.meta.name != 'chapters' ? 'pause' : 'play')
    }
  },
  beforeDestroy() {
    if(this.$tl)
      this.$tl.kill()
  },
  mounted() {

    this.$tl = new TimelineMax({ onComplete: ()=>{ this.completed = true }})
    this.$tl.from(this.$el, .1, { alpha: 0 })

    if(this.$parent.chapter.key == 'senate' && this.name == 'FR_B_NAR_01'
    || this.$parent.chapter.key == 'senate' && this.name == 'EN_B_NAR_01')
      this.$tl.set({}, { delay: 50 })

    _.each(this.$refs.subtitle, (subtitle, key) => {
      this.$tl.to(subtitle, .1, { display: 'block' })
      .set({}, { delay: this.getDelay(this.subtitles[key].length, key, this.name) })
      this.$tl.to(subtitle, .1, { display: 'none' })
    })

    this.$tl.to(this.$el, .1, { alpha: 0 })
    this.$tl.duration(this.getDuration(this.$parent.narration.duration, this.name))
  },

  methods: {
    playPauseChecker(action) {
      if(action == 'pause') this.$tl.pause()
      if(action == 'play' && !this.completed) this.$tl.play()
    },
    getDelay(time, key, name) {
      const exceptions = [
        { chapter: 'confederation_hall',  audio: 'EN_NAR_03', key: 0, update: -(time*.45) },
        { chapter: 'library_of_parliament',  audio: 'FR_NAR_02', key: 0, update: -(time*.45) },
        { chapter: 'library_of_parliament',  audio: 'FR_NAR_02', key: 1, update: -(time*.25) },
        { chapter: 'library_of_parliament',  audio: 'FR_NAR_02', key: 2, update: -(time*.30) },
        { chapter: 'senate',  audio: 'EN_A_NAR_03', key: 0, update: -(time*.30) },
      ]
      _.each(exceptions, (ex)=>{
        if(ex.chapter == this.$parent.chapter.key && ex.audio == name && ex.key == key) 
          time += ex.update
      })
      return time
    },
    getDuration(duration, name) {
      const exceptions = [
        { chapter: 'senate',  audio: 'FR_B_NAR_03', update: -33 },
        { chapter: 'senate',  audio: 'EN_B_NAR_03', update: -33 },
      ]
      _.each(exceptions, (ex)=>{
        if(ex.chapter == this.$parent.chapter.key && ex.audio == name) 
          duration += ex.update 

      })
      return duration
    },
  },
}
</script>

<style lang="stylus">
@import '~@/config/Settings'
@import '~@/commons/stylus/Media-queries'

.Subtitles
  position absolute
  bottom 40px
  left 20px
  right 20px
  color white
  text-align center
  line-height 18px
  z-index 500

  &__text
    display none
    background black 
    padding 10px

</style>
